import { AuthTypes } from './types';

export const loginDistributorRequest = (payload: any) => {
  return {
    type: AuthTypes.LOGIN_DISTRIBUTOR_REQUEST,
    payload,
  };
};
export const loginDistributorSuccess = (payload: any) => {
  return {
    type: AuthTypes.LOGIN_DISTRIBUTOR_SUCCESS,
    payload,
  };
};
export const loginDistributorFailure = (payload: any) => {
  return {
    type: AuthTypes.LOGIN_DISTRIBUTOR_FAILURE,
    payload,
  };
};
